import { Injectable, isDevMode } from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable} from "rxjs";
import {parseInt} from "lodash";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  env = isDevMode() ? environment.testMode : environment.productionMode;

  constructor(private mFirestore: AngularFirestore) { }

  addEducationQuestions(value: any): void {
    value.questionOrder =parseInt( value.questionOrder)

    this.mFirestore.collection(this.env.educationQuestionsList).add(value)
      .then(res => {
        console.log("Questions added successfully");
      })
      .catch(error => {
        console.error("Error adding questions:", error);
      });
  }
  updateEducationQuestions(value: any,id:string): void {
    value.questionOrder =parseInt( value.questionOrder)

    this.mFirestore.collection(this.env.educationQuestionsList).doc(id).update(value)
      .then(res => {
        console.log("Questions updated successfully");
      })
      .catch(error => {
        console.error("Error adding questions:", error);
      });
  }

  addCounsellingQuestions(value: any){
value.questionOrder =parseInt( value.questionOrder)
    this.mFirestore.collection(this.env.counsellingQuestionsList).add(value).then(res => {
      alert("Questions added successfully")
    })
  }


  getEducationQuestionList(): Observable<any[]> {
    return this.mFirestore.collection(this.env.educationQuestionsList,
      ref => ref.orderBy("questionOrder","asc",)).valueChanges({idField:'id'});
  }

  getCounsellingQuestionList(): Observable<any[]> {
    return this.mFirestore.collection(this.env.counsellingQuestionsList,
        ref => ref.orderBy("questionOrder","asc",)).valueChanges({idField:'id'});

  }


  // deleteEducationQuestion(questionId: string): void {
  //   this.mFirestore.collection(this.env.educationQuestionsList).doc(questionId).delete()
  //     .then(() => {
  //       console.log("Education question deleted successfully");
  //     })
  //     .catch(error => {
  //       console.error("Error deleting education question:", error);
  //     });
  // }

  deleteEducationQuestion(questionId: string) {
    return this.mFirestore
      .collection(this.env.educationQuestionsList)
      .doc(questionId)
      .delete();
  }


  deleteCounsellingQuestion(questionId: string): void {
    this.mFirestore.collection(this.env.counsellingQuestionsList).doc(questionId).delete()
      .then(() => {
        console.log("Counselling question deleted successfully");
      })
      .catch(error => {
        console.error("Error deleting counselling question:", error);
      });
  }

}
